import { Link, Navigate, useLocation, useNavigate, useParams } from "react-router-dom";
import { PAGES } from "../../../routeConfig";
import { BreadCrumb } from "../../../Layout/Common/breadCrumb";
import React, { Fragment, useEffect, useState } from "react";
import { useAuth } from "../../../Context/AuthContext";
import { useLoginModal } from "../../../Context/LoginModalContext";
import { axiosInstance, axiosWithoutAuth } from "../../../axios/axiosInstance";

import { PaidInvoices } from "./PaidInvoices";
import { PaymentRequired } from "./PaymentRequired";
import { useGlobalFunction } from "../../../Context/GlobalFunctionContext";
import { BacktoMyAccount } from "../backToMyAccount";
import "./PaymentRequired.css";
import { isValidArray, scrollToTop } from "../../../Layout/Common/common";
import { Spinner } from "../../../Layout/Common/spinner";
import { NoRecordFound } from "./NoRecordFound";
export const PayAccountMain = () => {
  const [activeTab, setActiveTab] = useState("Required");
  const [invoiceList, setInvoiceList] = useState([]);
  const [paidInvoices, setPaidInvoices] = useState([]);
  const navigate = useNavigate();
  const { userId, companyId, isAuthenticated } = useAuth();
  const { sendInvoiceSignal } = useGlobalFunction();
  const { showLoginModal } = useLoginModal();
  const [company_Id, setCompany_Id] = useState(null);
  const [onLoading, setOnLoading] = useState(true);
  const [paidLoading, setPaidLoading] = useState(true);
  const { urlref } = useParams();

  useEffect(() => {
    scrollToTop();
  }, [window.location.pathname]);

  useEffect(() => {
    getPendingInvoiceList(urlref);
    if (isAuthenticated) {
      getPaidInvoiceList();
    } else {
      setPaidLoading(false);
    }
  }, [urlref, companyId, isAuthenticated]);

  const getPendingInvoiceList = async (urlref) => {
    setOnLoading(true);
    var reqdata = {
      companyId: String(companyId ?? 0),
      urlRef: urlref,
    };
    try {
      const response = await axiosWithoutAuth.post("PayAccount/RequiredPayment", reqdata);
      setOnLoading(false);
      if (response && response.data) {
        let result = response.data;
        setInvoiceList(result.data);
        if (!companyId) setCompany_Id(String(result.companyId ?? "0"));
      } else {
        setInvoiceList(null);
      }
    } catch (error) {
      setOnLoading(false);
      setInvoiceList(null);
      console.error("Error fetching paid invoices:", error);
    }
  };
  const getPaidInvoiceList = async () => {
    setPaidLoading(true);
    var reqdata = {
      companyId: String(companyId ?? 0),
    };
    try {
      const response = await axiosWithoutAuth.post("PayAccount/PaidInvoice", reqdata);
      if (response && response.data) {
        let result = response.data;
        setPaidInvoices(result.data);
        if (companyId) setCompany_Id(String(result.companyId ?? "0"));
      } else {
        setPaidInvoices(null);
      }
    } catch (error) {
      setPaidInvoices(null);
      console.error("Error fetching paid invoices:", error);
    } finally {
      setPaidLoading(false);
    }
  };
  const GetInvoice = async () => {
    sendInvoiceSignal();
  };
  return (
    <Fragment>
      <BreadCrumb
        data={[
          { name: "My Account", url: "/myaccount" },
          { name: "Pay Account", url: PAGES.PAYACCOUNT },
        ]}
      />
      <div className="container-fluid container-lg payaccount">
        <div className="row">
          <div className="col-lg-12">
            <div className="acc-header py-3">
              <div className="myaccount-address myAccount-header">
                <h1 className="myaccount-title">Account Payment</h1>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="container-fluid col-lg-9 mt-2 p-3">
              {/* <div className="row">
                <div className="catalogueTabs-list">
                  <ul className="p-0 m-0">
                    <li className="nav-item">
                      <Link
                        className={`nav-link ${activeTab === "Required" ? "active" : ""}`}
                        onClick={(e) => {
                          e.preventDefault();
                          setActiveTab("Required");
                        }}
                      >
                        Payment Required
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        className={`nav-link ${activeTab === "Paid" ? "active" : ""}`}
                        onClick={(e) => {
                          e.preventDefault();
                          setActiveTab("Paid");
                        }}
                      >
                        Paid Invoices
                      </Link>
                    </li>
                  </ul>
                </div>
              </div> */}

              <div className="container tabs-row" role="tablist" aria-label="Comment category">
                <button
                  className={`tab-btn tab-paymentInvoice  ${activeTab === "Required" ? "active" : ""}`}
                  role="tab"
                  aria-selected="true"
                  data-key="paymentInvoice"
                  onClick={(e) => {
                    setActiveTab("Required");
                    scrollToTop();
                  }}
                >
                  <i className="ti ti-alert-triangle" aria-hidden="true" />
                  <span className="tab-text">Payment Required</span>
                </button>
                <button
                  className={`tab-btn tab-paidInvoice ${activeTab === "Paid" ? "active" : ""}`}
                  role="tab"
                  aria-selected="false"
                  data-key="paidInvoice"
                  onClick={(e) => {
                    if (!isAuthenticated) {
                      showLoginModal();
                      return;
                    }
                    setActiveTab("Paid");
                    scrollToTop();
                  }}
                >
                  <i className="ti ti-bulb" aria-hidden="true" />
                  <span className="tab-text">Paid Invoice</span>
                </button>
              </div>

              <div className="container-fluid container-lg">
                {/* Both panels stay mounted (so the invoice selection in
                    PaymentRequired survives a tab switch); active/inactive drive
                    the fade + zoom transition. */}
                <div className="fz-container">
                  <div className={`css-fade fz-panel ${activeTab === "Required" ? "active" : "inactive"}`}>
                    {onLoading ? (
                      <div className="payaccount-loading">
                        <Spinner />
                      </div>
                    ) : isValidArray(invoiceList) ? (
                      <PaymentRequired invoices={invoiceList} />
                    ) : (
                      <NoRecordFound message="No Invoice Found" icon="ti ti-file-invoice" />
                    )}
                  </div>
                  <div className={`css-fade fz-panel ${activeTab === "Paid" ? "active" : "inactive"}`}>
                    {paidLoading ? (
                      <div className="payaccount-loading">
                        <Spinner />
                      </div>
                    ) : isValidArray(paidInvoices) ? (
                      <PaidInvoices invoices={paidInvoices} />
                    ) : (
                      <NoRecordFound message="No Records Found" icon="ti ti-receipt" />
                    )}
                  </div>
                </div>
              </div>
              <BacktoMyAccount />
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export const PayAccountLegacyRedirect = () => {
  const { urlref } = useParams();
  const location = useLocation();
  const target = PAGES.PAYACCOUNT + (urlref ? "/" + encodeURIComponent(urlref) : "") + location.search + location.hash;
  return <Navigate to={target} replace />;
};
